// extracted by mini-css-extract-plugin
module.exports = {"container":"ProductListing_container__RLLt4","head":"ProductListing_head__Ibrz1","card":"ProductListing_card__Bj1pQ","link":"ProductListing_link__AAIe8"};